module.exports = __webpack_public_path__ + "static/img/new-user-invite-code.2fbc4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/new-user-invite-code.png
// module id = iRuc
// module chunks = 215